import React from "react";
import styled, { keyframes } from "styled-components";
import { HIGHLIGHTS } from "../../data/careers";

/* ─── ticker de áreas (fundo) ─── */
const AREAS_TICKER = [
  "TECNOLOGIA", "DESIGN", "PRODUTO", "MARKETING", "DADOS", "OPERAÇÕES",
  "FINANCEIRO", "VENDAS", "ENGENHARIA", "GROWTH", "PEOPLE", "FINTECH",
  "GAMES", "SEGURANÇA", "EDUCAÇÃO", "CONTABILIDADE",
];

const marquee = keyframes`from { transform: translateX(0); } to { transform: translateX(-50%); }`;
const fadeUp = keyframes`from { opacity: 0; transform: translateY(16px); } to { opacity: 1; transform: translateY(0); }`;

const SearchIco = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="11" cy="11" r="8" /><line x1="21" y1="21" x2="16.65" y2="16.65" />
  </svg>
);

const Band = styled.section`
  background: #0a0712;
  position: relative;
  overflow: hidden;
  border-bottom: 1px solid rgba(155, 81, 255, 0.2);

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    background:
      radial-gradient(ellipse 70% 60% at 82% 8%, rgba(155, 81, 255, 0.24) 0%, transparent 60%),
      radial-gradient(ellipse 55% 50% at 8% 88%, rgba(109, 40, 217, 0.16) 0%, transparent 65%),
      radial-gradient(ellipse 40% 35% at 50% 45%, rgba(155, 81, 255, 0.06) 0%, transparent 70%);
    pointer-events: none;
  }
`;

const Billboard = styled.div`
  position: absolute;
  inset: 0;
  pointer-events: none;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  mask-image: linear-gradient(180deg, transparent 0%, rgba(0,0,0,.55) 26%, rgba(0,0,0,.55) 74%, transparent 100%);
`;

const Row = styled.div`
  display: flex;
  white-space: nowrap;
  animation: ${marquee} ${(p) => p.$dur || "40s"} linear infinite ${(p) => (p.$rev ? "reverse" : "")};
  font-size: clamp(26px, 4.6vw, 60px);
  font-weight: 900;
  letter-spacing: 0.06em;
  color: transparent;
  -webkit-text-stroke: 1.5px rgba(155, 81, 255, 0.11);
  padding: 4px 0;
  user-select: none;

  @media (prefers-reduced-motion: reduce) { animation: none; }
`;

const Inner = styled.div`
  max-width: 1080px;
  margin: 0 auto;
  padding: clamp(64px, 10vw, 116px) clamp(16px, 4vw, 40px) clamp(48px, 7vw, 80px);
  position: relative;
  z-index: 1;
  animation: ${fadeUp} 0.6s ease both;
`;

const Pill = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 26px;
  padding: 5px 14px 5px 8px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 999px;

  img { height: 18px; width: auto; filter: brightness(0) invert(1); opacity: 0.9; }
  span {
    font-size: 0.7rem; font-weight: 700; color: rgba(255, 255, 255, 0.55);
    letter-spacing: 0.1em; text-transform: uppercase;
  }
  b {
    font-size: 0.7rem; font-weight: 800; color: #c9b3ff;
    letter-spacing: 0.04em;
  }
  i { width: 1px; height: 14px; background: rgba(255,255,255,.18); font-style: normal; }
`;

const Title = styled.h1`
  font-size: clamp(2.05rem, 6.4vw, 4.6rem);
  font-weight: 900;
  letter-spacing: -0.04em;
  line-height: 1.04;
  color: #fff;
  margin-bottom: 20px;
  max-width: 760px;
  overflow-wrap: break-word;

  em {
    font-style: normal;
    background: linear-gradient(135deg, #c084fc 0%, #9b51ff 48%, #7c3aed 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }
`;

const Sub = styled.p`
  font-size: clamp(0.96rem, 1.9vw, 1.12rem);
  color: rgba(255, 255, 255, 0.55);
  line-height: 1.7;
  max-width: 540px;
  margin-bottom: 34px;
`;

const Actions = styled.div`
  display: flex;
  gap: 12px;
  align-items: stretch;
  flex-wrap: wrap;
  max-width: 620px;
  margin-bottom: 44px;
`;

const SearchWrap = styled.div`
  position: relative;
  flex: 1;
  min-width: 240px;
`;

const Input = styled.input`
  width: 100%;
  height: 54px;
  padding: 0 18px 0 48px;
  background: rgba(255, 255, 255, 0.06);
  border: 1.5px solid rgba(255, 255, 255, 0.12);
  border-radius: 13px;
  color: #fff;
  font-size: 0.93rem;
  font-family: inherit;
  outline: none;
  transition: border-color 0.15s, background 0.15s, box-shadow 0.15s;

  &::placeholder { color: rgba(255, 255, 255, 0.3); }
  &:focus {
    border-color: rgba(155, 81, 255, 0.7);
    background: rgba(255, 255, 255, 0.09);
    box-shadow: 0 0 0 3px rgba(155, 81, 255, 0.18);
  }
`;

const IcoWrap = styled.div`
  position: absolute;
  left: 16px; top: 50%;
  transform: translateY(-50%);
  color: rgba(255, 255, 255, 0.34);
  display: flex;
  pointer-events: none;
`;

const CtaBtn = styled.button`
  all: unset;
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 54px;
  padding: 0 26px;
  background: linear-gradient(135deg, #9b51ff, #7c3aed);
  color: #fff;
  font-weight: 800;
  font-size: 0.92rem;
  border-radius: 13px;
  cursor: pointer;
  box-shadow: 0 6px 22px rgba(124, 58, 237, 0.4);
  transition: filter 0.14s, transform 0.12s, box-shadow 0.14s;

  &:hover { filter: brightness(1.08); transform: translateY(-2px); box-shadow: 0 10px 30px rgba(124, 58, 237, 0.5); }
  &:active { transform: translateY(0); }
`;

const Stats = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0;
`;

const Stat = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3px;
  padding-right: 28px;
  margin-right: 28px;
  border-right: 1px solid rgba(255, 255, 255, 0.1);

  &:last-child { border-right: none; padding-right: 0; margin-right: 0; }
  @media (max-width: 520px) { padding-right: 16px; margin-right: 16px; }
`;

const Num = styled.span`
  font-size: 1.35rem;
  font-weight: 800;
  color: #fff;
  letter-spacing: -0.03em;
`;

const Lbl = styled.span`
  font-size: 0.66rem;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.4);
  letter-spacing: 0.06em;
  text-transform: uppercase;
`;

export default function Hero({ search, setSearch, jobCount, loading, onSeeJobs }) {
  const ticker = [...AREAS_TICKER, ...AREAS_TICKER];

  return (
    <Band aria-label="Carreiras na Guebly">
      <Billboard aria-hidden="true">
        <Row $dur="46s">{ticker.map((w, i) => <span key={i}>{w}&nbsp;&nbsp;·&nbsp;&nbsp;</span>)}</Row>
        <Row $dur="36s" $rev>{ticker.slice(6).concat(ticker.slice(0, 6)).map((w, i) => <span key={i}>{w}&nbsp;&nbsp;·&nbsp;&nbsp;</span>)}</Row>
        <Row $dur="52s">{ticker.map((w, i) => <span key={i}>{w}&nbsp;&nbsp;·&nbsp;&nbsp;</span>)}</Row>
      </Billboard>

      <Inner>
        <Pill>
          <img src="/guebly-logo.png" alt="" />
          <span>Carreiras</span>
          <i aria-hidden="true" />
          <b>Holding · 6 empresas</b>
        </Pill>

        <Title>
          Construa o futuro<br />
          <em>em uma holding inteira.</em>
        </Title>

        <Sub>
          Não é uma vaga numa empresa só. É entrar num grupo com 6 frentes e 25+ produtos
          em construção — de fintech a games, de contabilidade a IA de segurança. Time enxuto,
          remoto de verdade, execução real.
        </Sub>

        <Actions>
          <SearchWrap>
            <IcoWrap aria-hidden="true"><SearchIco /></IcoWrap>
            <Input
              aria-label="Buscar vagas por cargo, área ou tecnologia"
              placeholder="Cargo, área ou tecnologia…"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </SearchWrap>
          <CtaBtn onClick={onSeeJobs} aria-label="Ver vagas abertas">
            Ver vagas <span aria-hidden="true">↓</span>
          </CtaBtn>
        </Actions>

        <Stats>
          <Stat>
            <Num>{loading ? "—" : jobCount}</Num>
            <Lbl>vagas abertas</Lbl>
          </Stat>
          {HIGHLIGHTS.map((s) => (
            <Stat key={s.label}>
              <Num>{s.value}</Num>
              <Lbl>{s.label}</Lbl>
            </Stat>
          ))}
        </Stats>
      </Inner>
    </Band>
  );
}
